import { useMutation } from '@tanstack/react-query';
import passwordResetService from '../services/passwordResetService';

/**
 * Hook for requesting a password reset
 * @returns Mutation function and state for password reset request
 */
export const useRequestPasswordReset = () => {
  return useMutation({
    mutationFn: (email: string) =>
      passwordResetService.requestPasswordReset(email)
  });
};

/**
 * Hook for validating a reset token
 * @returns Mutation function and state for token validation
 */
export const useValidateResetToken = () => {
  return useMutation({
    mutationFn: (token: string) =>
      passwordResetService.validateResetToken(token)
  });
};

/**
 * Interface for reset password parameters
 */
export interface ResetPasswordParams {
  token: string;
  password: string;
  confirmPassword: string;
}

/**
 * Hook for resetting a password with a valid token
 * @returns Mutation function and state for password reset
 */
export const useResetPassword = () => {
  return useMutation({
    mutationFn: ({ token, password, confirmPassword }: ResetPasswordParams) =>
      passwordResetService.resetPassword(token, password, confirmPassword)
  });
};
